(function () {
    console.log("carousel.script.js");
    const carousel = tns({
        container: '.carousel',
        items: 1,
        slideBy: 'page',
        autoplay: false,
        controls: true,
        nav: false,
        freezable: false,
        speed: 1000,
        gutter: '30px',
    });
      
})();
